<template>
	<div class="flipbook-page" v-loading="resolving" element-loading-text="加载中...">
		<pdf-flip-book v-if="pdfUrl" :key="pdfUrl" :pdf-url="pdfUrl"></pdf-flip-book>
		<el-empty v-else-if="errorMsg" :description="errorMsg"></el-empty>
	</div>
</template>

<script>
// PDF 在线翻书阅读页
// 两种打开方式：
//   1. /mediaCenter/flipBook?url=/xxx.pdf   直接指定 PDF 地址（站点内或完整 http 链接）
//   2. /mediaCenter/flipBook?id=123         传新闻 ID，从 JavaOA(hzfgl-sys) 新闻详情接口
//                                           /news/public/detail/{id} 取 saveFilePDF 字段
//                                           PDF 文件实体在附件服务器 rhjtoa.ruihepm.com 上
import PdfFlipBook from '../../components/PdfFlipBook'
import axios from 'axios'

// 附件文件服务器（与 group-oa 的 VITE_FILE_URL 保持一致）
const FILE_BASE = process.env.VUE_APP_FILE_URL || 'https://rhjtoa.ruihepm.com'
// JavaOA hzfgl-sys 接口前缀（开发走 devServer 代理，生产由 nginx 转发到网关）
const JAVAOA_API = process.env.VUE_APP_HZFGLSYS_API || '/hzfglSys'

export default {
	name: 'FlipBook',
	components: { PdfFlipBook },
	data() {
		return {
			resolving: false,
			pdfUrl: '',
			errorMsg: ''
		}
	},
	watch: {
		'$route.query': 'resolve'
	},
	mounted() {
		this.resolve()
	},
	methods: {
		async resolve() {
			const { id, url } = this.$route.query
			this.errorMsg = ''
			this.pdfUrl = ''
			// 方式1：直接指定 PDF 地址
			if (url) {
				this.pdfUrl = url
				return
			}
			if (!id) {
				this.errorMsg = '缺少参数：请传入新闻 id（?id=）或 PDF 地址（?url=）'
				return
			}
			// 方式2：新闻 ID → JavaOA 新闻详情接口 → saveFilePDF
			// 注：JavaOA 返回 code:'200'，与 Request.js 拦截器约定('v'/'pglist')不同，故单独用 axios
			this.resolving = true
			try {
				const res = await axios.get(JAVAOA_API + '/news/public/detail/' + id)
				const data = res.data && res.data.data
				if (res.data.code !== '200' || !data) {
					this.errorMsg = (res.data && res.data.msg) || '新闻不存在'
					return
				}
				const pdf = data.saveFilePDF
				if (!pdf) {
					this.errorMsg = '该新闻未包含 PDF 附件，无法翻书阅读'
					return
				}
				if (/^https?:\/\//i.test(pdf)) {
					this.pdfUrl = pdf
				} else if (pdf.indexOf('/oos_v2/') === 0) {
					// devServer 的 /oos 代理按前缀匹配会命中 /oos_v2，转发到附件服务器（同源无跨域）
					this.pdfUrl = pdf
				} else {
					// 其它相对路径（旧 /UpFile 等）直连附件服务器
					this.pdfUrl = FILE_BASE + pdf
				}
			} catch (e) {
				console.error(e)
				this.errorMsg = '获取新闻详情失败'
			} finally {
				this.resolving = false
			}
		}
	}
}
</script>

<style lang="less" scoped>
.flipbook-page {
	max-width: 1200px;
	margin: 0 auto;
	padding: 10px 0 30px;
	min-height: 300px;
}
</style>
